module.exports = __webpack_public_path__ + "media/images/doctor_PNG15987_full-03f04e903203f7e147a746b2fdd06d14.png";